/* TD Draft 2026-10-06 FINDER — Therapiedecken-Finder (sections/td-finder.liquid, loaded only by that section).
   Question paths: Erwachsene: who → size → weight → warm → closure → colour → result (6 questions);
   Kind: who → height → weight → closure → result (4); Kind über 170 cm: who → height → weight → warm → closure → colour → result.
   Weight classes come from the section settings (same tables as the weight guide page); products from the JSON block.
   Size and weight are read from the option values ("135 x 200 cm", "8 kg"); the closure ("Bezugsart") is recognised by
   keywords in all six shop languages (order of the values differs per product and language). Only available variants
   are offered; the body weight never leaves the page.
   TD Draft 2026-10-06 FINDER2 — Felix 06.10.2026:
   - "yes": just above a class boundary (body weight < lower bound + boundary_margin) the finder recommends the LIGHTER class
     and names the heavier one in a note (support tickets: "too heavy" about twice as often as "too light").
   - "Maybe the finder needs to ask about Bezugsart too?": own question (Schlaufen / Reißverschluss / weiß nicht),
     the result keeps the switch.
   - "Übersetzen … now": every visible text is a section setting (template translations); prices are formatted by Liquid
     (| money, presentment currency), "bzw." is a setting, size/weight/closure parsing is language-independent.
   TD Draft 2026-10-06 FINDER4 — Felix 06.10.2026: "On mobile every time I answer a question it moves up to the top of the page
   also maybe allow a back button":
   - no jump: the page only scrolls when the card's top edge is hidden under the sticky header (--sticky-area-height),
     and then just below the header — never to the section/page top;
   - "‹ Zurück" buttons above and under every question. The answers simply stay in the page; every step in the internal
     path remembers its own audience and size. Coming back from a product page (or a reload) restores answers + step from
     sessionStorage (this tab only).
   - The phone's back gesture is NOT intercepted (Codex r6–r9: browsers skip history entries a page creates without a
     fresh tap, so any back trap is unreliable) — it leaves the page as usual; the answers are restored on return. */
(function () {
  'use strict';

  function sizeKey(s) { var m = /(\d+)\s*[x×]\s*(\d+)/i.exec(s || ''); return m ? m[1] + 'x' + m[2] : null; }
  function sizeLabel(k) { return k ? k.replace('x', ' × ') + ' cm' : ''; }
  function kgOf(s) { var m = /^\s*(\d+(?:[.,]\d+)?)\s*kg\s*$/i.exec(s || ''); return m ? parseFloat(m[1].replace(',', '.')) : null; }
  function nums(s) { return (s.match(/\d+(?:[.,]\d+)?/g) || []).map(function (x) { return parseFloat(x.replace(',', '.')); }); }
  // "bis 69 kg", "70–89 kg", "ab 110 kg", "über 170 cm" — also tolerant of translated words
  var RE_TO = /bis|unter|up to|under|below|jusqu|moins|hasta|menos|fino|sotto|tot|onder|max/i;
  var RE_FROM = /\bab\b|über|uber|from|over|above|à partir|partir|plus de|desde|más de|mas de|\bda\b|oltre|vanaf|boven|min|\+/i;
  function rangeOf(left) {
    var l = left.toLowerCase().replace(/[–—]/g, '-'), n = nums(l);
    if (n.length >= 2) return [n[0], n[1]];
    if (n.length === 1) {
      if (RE_TO.test(l)) return [0, n[0]];
      if (RE_FROM.test(l)) return [/über|uber|over|above|plus de|más de|mas de|oltre|boven/.test(l) ? n[0] + 0.001 : n[0], 9999];
      return [n[0], n[0]];
    }
    return null;
  }
  function lines(s) { return (s || '').split(/\r?\n/).map(function (x) { return x.trim(); }).filter(Boolean); }
  function byLo(a, b) { return a.lo - b.lo; }
  function parseAdult(s) {
    var out = [];
    lines(s).forEach(function (ln) {
      var kv = ln.split('='); if (kv.length < 2) return;
      var r = rangeOf(kv[0]); if (!r) return;
      var w = kv[1].split('|'), a = nums(w[0] || ''), b = nums(w[1] || '');
      if (!a.length) return;
      out.push({ lo: r[0], hi: r[1], a: a[0], b: b.length ? b[0] : null });
    });
    return out.sort(byLo);
  }
  function parseKids(s) {
    var out = [];
    lines(s).forEach(function (ln) {
      var kv = ln.split('='); if (kv.length < 2) return;
      var r = rangeOf(kv[0]); if (!r) return;
      var w = kv[1].split('|'), k = nums(w[0] || ''), sizes = [], re = /(\d+)\s*[×x]\s*(\d+)/g, m;
      if (!k.length) return;
      while ((m = re.exec(w[1] || ''))) sizes.push(m[1] + 'x' + m[2]);
      out.push({ lo: r[0], hi: r[1], kg: k[0], sizes: sizes });
    });
    return out.sort(byLo);
  }
  function parseHeights(s) {
    var out = [];
    lines(s).forEach(function (ln) {
      var kv = ln.split('='); if (kv.length < 2) return;
      var k = sizeKey(kv[1]); if (!k) return;
      out.push({ label: kv[0].trim(), size: k });
    });
    return out;
  }
  function parseColours(s) {
    // "Label | #hex = value, value …" (the swatch part is optional; "bunt" = multicoloured dot)
    var out = [];
    lines(s).forEach(function (ln) {
      var kv = ln.split('='); if (kv.length < 2) return;
      var lab = kv[0].split('|'), sw = (lab[1] || '').trim();
      out.push({ label: lab[0].trim(), swatch: /^#[0-9a-f]{3,8}$/i.test(sw) ? sw : (/bunt|multi|colou?r/i.test(sw) ? 'multi' : ''),
        vals: kv.slice(1).join('=').split(',').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean) });
    });
    return out;
  }
  function inRange(rows, bw) { for (var i = 0; i < rows.length; i++) if (bw >= rows[i].lo && bw <= rows[i].hi) return rows[i]; return null; }
  function decode(s) { var ta = document.createElement('textarea'); ta.innerHTML = String(s || '').replace(/<[^>]*>/g, ''); return ta.value; }
  function cleanMoney(s) { return decode(s).replace(/[\s  ]+(€|%)/g, '$1').trim(); }
  function money(cents, fmt) {
    var v = (cents || 0) / 100, f = fmt || '{{amount_with_comma_separator}}€';
    function grp(n, d, t, s) { var p = n.toFixed(d).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, t); return p.join(s); }
    return cleanMoney(f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_with_comma_separator') return grp(v, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return grp(v, 0, '.', ',');
      if (k === 'amount_no_decimals') return grp(v, 0, ',', '.');
      if (k === 'amount_with_apostrophe_separator') return grp(v, 2, "'", '.');
      return grp(v, 2, ',', '.');
    }));
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fill(tpl, map) { return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) { return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m; }); }
  // closure value → loop / zip / med / any (anything else, e.g. a motif name), in de / en / fr / es / it / nl.
  // Whole labels only (optionally followed by a qualifier such as "(Standard)"), so motif names like "Dessin" or
  // "Lustige Tiere" stay "any".
  var END = '(?=$|[\\s(,\\-])';
  var RE_MED = new RegExp('^(medizinisch|medical|médical|medica|médica|medisch|ohne|none|without|sans|sin|senza|zonder)' + END, 'i');
  var RE_ZIP = new RegExp('^(reißverschluss|reissverschluss|zipper|zip|fermeture éclair|fermeture|cremallera|cerniera|ritssluiting|rits)' + END, 'i');
  var RE_LOOP = new RegExp('^(schlaufen|loops|loop|boucles|lazos|passanti|lussen)' + END, 'i');
  function clType(v) {
    var s = (v || '').trim();
    if (!s) return 'any';
    if (RE_MED.test(s)) return 'med';
    if (RE_ZIP.test(s)) return 'zip';
    if (RE_LOOP.test(s)) return 'loop';
    return 'any';
  }
  function prep(p, idx) {
    var sizeIdx = -1, kgIdx = -1, clIdx = -1;
    (p.ov || []).forEach(function (vals, i) {
      if (vals.some(function (v) { return sizeKey(v); })) sizeIdx = i;
      else if (vals.length && vals.every(function (v) { return kgOf(v) !== null; })) kgIdx = i;
      else clIdx = i;
    });
    if (sizeIdx < 0 || kgIdx < 0) return null;
    var vars = (p.v || []).map(function (a) {
      var o = [a[1], a[2], a[3]], cl = clIdx >= 0 ? o[clIdx] : '';
      return { id: a[0], size: sizeKey(o[sizeIdx]), kg: kgOf(o[kgIdx]), cl: cl || '', type: clType(cl), avail: a[4] === 1, price: a[5], priceText: a[6] };
    });
    var cs = Array.isArray(p.c) ? p.c : (p.c ? [p.c] : []);
    return { p: p, idx: idx, vars: vars, colours: cs.map(function (x) { return String(x).toLowerCase(); }) };
  }
  function shortTitle(t) {
    // drop the brand prefix before the first " - " ("Original Therapiedecke - …", "Couverture thérapeutique originale - …", …)
    var s = String(t || '').replace(/^[^-–]*(therap|original)[^-–]*\s[-–]\s*/i, '')
      .replace(/\s+(für|for|pour|para|per|voor)\s+(Erwachsene|Kinder|adults?|kids|children|adultes|enfants|adultos|niños|adulti|bambini|volwassenen|kinderen)(\s*(und|and|&|et|y|e|en)\s*(Erwachsene|Kinder|adults?|kids|children|adultes|enfants|adultos|niños|adulti|bambini|volwassenen|kinderen))?\s*$/i, '');
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  function init(root) {
    if (root.__tdFd) return;
    root.__tdFd = true;
    var dataEl = root.querySelector('[data-td-fd-data]');
    if (!dataEl) return;
    var D;
    try { D = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var T = D.txt || {};
    var rows = { '135x200': parseAdult(D.rows['135x200']), '150x220': parseAdult(D.rows['150x220']), kids: parseKids(D.rows.kids) };
    var heights = parseHeights(D.heights), colours = parseColours(D.colours);
    var kidsAdultFrom = parseInt(D.kidsAdultFrom, 10) || 71;
    var margin = parseFloat(D.margin); if (!(margin >= 0)) margin = 0;
    var prods = { a: (D.p.a || []).map(prep).filter(Boolean), k: (D.p.k || []).map(prep).filter(Boolean) };

    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    function icon(name) { var t = root.querySelector('template[data-td-fd-tpl="' + name + '"]'); return t ? t.innerHTML : ''; }
    var steps = {}; qa('[data-td-fd-step]').forEach(function (el) { steps[el.getAttribute('data-td-fd-step')] = el; });
    var range = q('[data-td-fd-range]'), kgOut = q('[data-td-fd-kg]'), qWeight = q('[data-td-fd-qweight]');
    var S, hist;
    var LIVE = document.createElement('p');
    LIVE.className = 'td-fd__live';
    LIVE.setAttribute('aria-live', 'polite');
    range.parentNode.insertBefore(LIVE, range.parentNode.querySelector('.td-fd__scale').nextSibling);
    var BOUND = document.createElement('p');
    BOUND.className = 'td-fd__bound';
    BOUND.hidden = true;
    LIVE.parentNode.insertBefore(BOUND, LIVE.nextSibling);
    var ABOVE = document.createElement('div');
    ABOVE.className = 'td-fd__above';
    ABOVE.hidden = true;
    BOUND.parentNode.insertBefore(ABOVE, BOUND.nextSibling);

    function reset() {
      S = { who: null, group: null, size: null, bw: null, warm: null, colours: [], closure: 'loop', boundary: null, shown: 0, list: [], sw: false, kidSize: null };
      hist = [];
    }
    function flow() {
      if (S.who === 'k') return S.group === 'a' ? ['who', 'height', 'weight', 'warm', 'closure', 'colour', 'result'] : ['who', 'height', 'weight', 'closure', 'result'];
      return ['who', 'size', 'weight', 'warm', 'closure', 'colour', 'result'];
    }
    function setClosure(c) {
      S.closure = c === 'zip' ? 'zip' : 'loop';
      qa('[data-td-fd-cl]').forEach(function (x) { x.setAttribute('aria-pressed', x.getAttribute('data-td-fd-cl') === S.closure ? 'true' : 'false'); });
      var n = q('[data-td-fd-clnote]'); n.textContent = n.getAttribute(S.closure === 'zip' ? 'data-zip' : 'data-loop');
    }
    function show(name, push, focus) {
      if (push !== false && S.step && S.step !== name) hist.push({ step: S.step, who: S.who, group: S.group, size: S.size });
      S.step = name;
      if (name === 'height') S.group = 'k';
      Object.keys(steps).forEach(function (k) { steps[k].hidden = k !== name; });
      var f = flow(), n = f.indexOf(name), m = f.length - 1;
      q('[data-td-fd-bar]').hidden = name === 'who';
      q('[data-td-fd-count]').textContent = name === 'result' || n < 0 ? '' : fill(T.count, { n: n + 1, m: m });
      q('[data-td-fd-progress]').style.width = (n < 0 ? 0 : Math.round((n / m) * 100)) + '%';
      if (name === 'weight') setupWeight();
      if (name === 'height') setupHeights();
      if (name === 'colour') setupColours();
      if (name === 'result') renderResult();
      q('[data-td-fd-navbar]').hidden = name === 'who';
      if (focus !== false) {
        var h = steps[name].querySelector('.td-fd__q');
        if (h) { try { h.focus({ preventScroll: true }); } catch (e) { /* no focus without preventScroll: it could scroll */ } }
        keepInView();
      }
    }
    // ---------- scrolling: keep the card's top edge visible below the sticky header, never jump to the page top
    function stickyTop() {
      // --sticky-area-height is a calc() expression in this theme, so measure it instead of parsing it
      var pr = document.createElement('div'), h = 0;
      pr.style.cssText = 'position:absolute;top:0;left:0;width:1px;visibility:hidden;pointer-events:none;height:var(--sticky-area-height,0px)';
      document.body.appendChild(pr); h = pr.getBoundingClientRect().height; pr.parentNode.removeChild(pr);
      return h || 0;
    }
    function keepInView(instant) {
      var card = q('[data-td-fd-card]'), r = card.getBoundingClientRect(), top = stickyTop() + 8;
      if (r.top >= top && r.top <= window.innerHeight - 160) return;
      var smooth = !instant && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
      try { window.scrollTo({ top: window.pageYOffset + r.top - top, behavior: smooth ? 'smooth' : 'auto' }); } catch (e) { window.scrollTo(0, window.pageYOffset + r.top - top); }
    }
    // ---------- back: in-page buttons only; answers stay in the page, sessionStorage restores them after a product visit
    var initStep = 'who', initHist = [];
    var KEY = 'td-fd:' + location.pathname;
    function persist() {
      try {
        sessionStorage.setItem(KEY, JSON.stringify({ v: 2, step: S.step, who: S.who, group: S.group, size: S.size, sw: S.sw, kidSize: S.kidSize,
          bw: S.bw, warm: S.warm, closure: S.closure, colours: S.colours.map(function (c) { return c.label; }) }));
      } catch (e) { /* private mode etc. */ }
    }
    function forget() { try { sessionStorage.removeItem(KEY); } catch (e) { /* ignore */ } }
    function go(name) { show(name); persist(); }
    function back() {
      var e = hist.pop();
      if (!e) { if (S.step !== 'who') { show('who', false); persist(); } return; }   // never a dead button
      S.who = e.who; S.group = e.group; S.size = e.size;
      if (S.sw && e.step === 'weight' && e.group === 'k') { S.sw = false; S.kidSize = null; }   // back across the kids → adults switch
      show(e.step, false);
      persist();
    }
    // ---------- weight
    function classInfo() {
      var rws = S.group === 'k' ? rows.kids : (rows[S.size] || rows['135x200']);
      var c = inRange(rws, S.bw), i = c ? rws.indexOf(c) : -1;
      S.boundary = null;
      if (!c) return null;
      // just above the lower bound of a class → recommend the lighter class (Felix 06.10.2026)
      if (margin > 0 && i > 0 && c.lo > 0 && S.bw - c.lo < margin) { S.boundary = c; return rws[i - 1]; }
      return c;
    }
    function kgText(c) {
      if (!c) return '';
      if (c.kg != null) return String(c.kg).replace('.', ',') + ' kg';
      return c.b != null ? String(c.a).replace('.', ',') + ' kg ' + (T.or || 'bzw.') + ' ' + String(c.b).replace('.', ',') + ' kg' : String(c.a).replace('.', ',') + ' kg';
    }
    function setupWeight() {
      var kid = S.group === 'k';
      var min = kid ? 10 : 40, max = kid ? 80 : 150, start = kid ? 30 : 72;
      // keep a weight given on the other path (kids ⇄ adults): widen the slider instead of resetting it (Codex r8)
      if (S.bw != null) { min = Math.min(min, S.bw); max = Math.max(max, S.bw); }
      range.min = min; range.max = max;
      if (S.bw == null) S.bw = start;
      range.value = S.bw;
      q('[data-td-fd-min]').textContent = min + ' kg';
      q('[data-td-fd-max]').textContent = max + ' kg';
      qWeight.textContent = kid ? qWeight.getAttribute('data-k') : qWeight.getAttribute('data-a');
      range.setAttribute('aria-label', qWeight.textContent);
      q('[data-td-fd-kidnote]').hidden = !kid;
      updWeight();
    }
    function updWeight() {
      S.bw = parseInt(range.value, 10);
      kgOut.textContent = S.bw + ' kg';
      range.setAttribute('aria-valuetext', S.bw + ' kg');
      var pct = (S.bw - range.min) / (range.max - range.min) * 100;
      range.style.setProperty('--td-fd-fill', pct + '%');
      var c = classInfo(), next = q('[data-td-fd-next="weight"]');
      ABOVE.hidden = true; ABOVE.innerHTML = ''; BOUND.hidden = true;
      if (S.group === 'k' && S.bw >= kidsAdultFrom) {
        LIVE.textContent = fill(T.kidsAbove, { kg: kidsAdultFrom });
        ABOVE.hidden = false;
        ABOVE.innerHTML = '<button type="button" class="td-fd__switch">' + esc(T.kidsAboveBtn) + '</button>';
        ABOVE.firstChild.addEventListener('click', function () {
          hist.push({ step: 'weight', who: S.who, group: S.group, size: S.size });
          S.sw = true; S.kidSize = S.size;
          S.who = 'a'; S.group = 'a'; S.size = null;
          show('size', false); persist();
        });
        next.disabled = true;
      } else if (!c) {
        LIVE.textContent = fill(T.recNone, { bw: S.bw });
        next.disabled = true;
      } else {
        LIVE.textContent = fill(T.liveWeight, { kg: kgText(c) });
        if (S.boundary) { BOUND.textContent = fill(T.boundaryShort, { kg: kgText(S.boundary) }); BOUND.hidden = false; }
        next.disabled = false;
      }
    }
    range.addEventListener('input', updWeight);
    range.addEventListener('change', function () { persist(); });
    qa('[data-td-fd-nudge]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(range.value, 10) + parseInt(b.getAttribute('data-td-fd-nudge'), 10);
        range.value = Math.max(+range.min, Math.min(+range.max, v)); updWeight(); persist();
      });
    });

    // ---------- kids: body height → size
    function setupHeights() {
      var box = q('[data-td-fd-heights]');
      if (box.childNodes.length) return;
      heights.forEach(function (h, i) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'td-fd__opt';
        b.innerHTML = '<span class="td-fd__ico">' + icon('ruler-' + Math.min(i + 1, 4)) + '</span><span class="td-fd__opt-tx"><span class="td-fd__opt-t">' + esc(h.label) + '</span><span class="td-fd__opt-s">' + esc(sizeLabel(h.size)) + '</span></span>';
        b.addEventListener('click', function () {
          var isKid = rows.kids.some(function (r) { return r.sizes.indexOf(h.size) >= 0; });
          S.size = h.size;
          S.group = isKid ? 'k' : 'a';
          go('weight');
        });
        box.appendChild(b);
      });
    }

    // ---------- colours
    function setupColours() {
      var box = q('[data-td-fd-chips]');
      if (box.childNodes.length) return;
      colours.forEach(function (c) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'td-fd__chip'; b.setAttribute('aria-pressed', 'false');
        if (c.swatch) {
          var dot = document.createElement('span');
          dot.className = 'td-fd__dot' + (c.swatch === 'multi' ? ' td-fd__dot--multi' : '');
          if (c.swatch !== 'multi') dot.style.background = c.swatch;
          dot.setAttribute('aria-hidden', 'true');
          b.appendChild(dot);
        }
        b.appendChild(document.createTextNode(c.label));
        b.addEventListener('click', function () {
          var on = b.getAttribute('aria-pressed') !== 'true';
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
          S.colours = qa('.td-fd__chip').map(function (x, j) { return x.getAttribute('aria-pressed') === 'true' ? colours[j] : null; }).filter(Boolean);
          persist();
        });
        box.appendChild(b);
      });
    }

    // ---------- result
    function pick(pr, size, kgs) {
      var c = pr.vars.filter(function (v) { return v.avail && v.size === size && kgs.indexOf(v.kg) >= 0; });
      if (!c.length) return null;
      var order = S.closure === 'zip' ? ['zip', 'any', 'loop', 'med'] : ['loop', 'any', 'zip', 'med'];
      c.sort(function (x, y) { return (order.indexOf(x.type) - order.indexOf(y.type)) || (x.price - y.price); });
      return c[0];
    }
    function listFor(size, kgs) {
      var list = (S.group === 'k' ? prods.k : prods.a).map(function (pr) {
        var v = pick(pr, size, kgs);
        if (!v) return null;
        var score = 0;
        if (S.group !== 'k' && S.warm) score += pr.p.w ? 6 - 3 * Math.abs(pr.p.w - S.warm) : 1;
        if (S.group !== 'k' && S.colours.length) {
          var hit = S.colours.some(function (cg) { return cg.vals.some(function (x) { return pr.colours.indexOf(x) >= 0; }); });
          if (hit) score += 3;
        }
        if (v.type === S.closure) score += 2;
        return { pr: pr, v: v, score: score };
      }).filter(Boolean);
      list.sort(function (x, y) { return (y.score - x.score) || (x.pr.idx - y.pr.idx); });
      return list;
    }
    function build() {
      var c = classInfo(), size = S.size, kgs, note = '', list = [];
      if (!c) return { c: null, items: [] };
      if (S.group === 'k') {
        kgs = [c.kg];
        // kids: the chosen size first (if the class has it), then the class's other sizes, nearest first — by real, available variants
        var all = ['90x120', '100x150', '110x170'], at = all.indexOf(size);
        var order = (c.sizes.length && c.sizes.indexOf(size) < 0 ? [] : [size]).concat(c.sizes.filter(function (s) { return s !== size; }).sort(function (x, y) { return Math.abs(all.indexOf(x) - at) - Math.abs(all.indexOf(y) - at); }));
        for (var i = 0; i < order.length && !list.length; i++) {
          list = listFor(order[i], kgs);
          if (list.length && order[i] !== size) { note = fill(T.sizeMoved, { kg: String(c.kg).replace('.', ','), size: sizeLabel(size), 'new': sizeLabel(order[i]) }); size = order[i]; }
        }
      } else {
        kgs = c.b != null ? [c.a, c.b] : [c.a];
        list = listFor(size, kgs);
      }
      return { c: c, size: size, kgs: kgs, note: note, items: list, hasZip: list.some(function (x) { return x.pr.vars.some(function (v) { return v.type === 'zip' && v.avail && v.size === size && kgs.indexOf(v.kg) >= 0; }); }) };
    }
    function card(it) {
      var p = it.pr.p, v = it.v, sep = p.u.indexOf('?') >= 0 ? '&' : '?';
      var warm = S.group === 'k' ? '' : (p.w === 4 ? T.warm4 : p.w === 3 ? T.warm3 : p.w === 2 ? T.warm2 : '');
      var parts = [];
      if (v.cl) parts.push(v.cl + ((S.closure === 'zip' && v.type === 'loop') || (S.closure === 'loop' && v.type === 'zip') ? ' (' + T.other + ')' : ''));
      parts.push(sizeLabel(v.size)); parts.push(String(v.kg).replace('.', ',') + ' kg');
      var price = v.priceText ? cleanMoney(v.priceText) : money(v.price, D.money);
      return '<li class="td-fd__item"><a class="td-fd__link" href="' + esc(p.u + sep + 'variant=' + v.id) + '">' +
        '<span class="td-fd__img">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy" width="600" height="600">' : '') + '</span>' +
        '<span class="td-fd__txt"><span class="td-fd__name">' + esc(shortTitle(p.t)) + '</span>' +
        (warm ? '<span class="td-fd__tag">' + esc(warm) + '</span>' : '') +
        '<span class="td-fd__var">' + esc(parts.join(' · ')) + '</span>' +
        '<span class="td-fd__price">' + esc(price) + '</span>' +
        '<span class="td-fd__cta">' + esc(T.view) + '</span></span></a></li>';
    }
    function renderResult() {
      var r = build(), rec = q('[data-td-fd-rec]'), grid = q('[data-td-fd-grid]'), more = q('[data-td-fd-more]');
      var tpl = S.group === 'k' ? T.recK : T.recA;
      if (!r.c) { rec.innerHTML = '<p>' + esc(fill(T.recNone, { bw: S.bw })) + '</p>'; grid.innerHTML = ''; more.hidden = true; q('[data-td-fd-empty]').hidden = true; q('[data-td-fd-closure]').hidden = true; return; }
      rec.innerHTML = '<div class="td-fd__recbox"><span class="td-fd__ico td-fd__ico--big">' + icon('weight') + '</span><div class="td-fd__rec-tx">' +
        '<p class="td-fd__rec-kg">' + esc(kgText(r.c)) + '<span>' + esc(sizeLabel(r.size)) + '</span></p>' +
        '<p class="td-fd__rec-main">' + esc(fill(tpl, { bw: S.bw, kg: kgText(r.c), size: sizeLabel(r.size) })) + '</p></div></div>' +
        (S.boundary ? '<p class="td-fd__rec-note">' + icon('info') + '<span>' + esc(fill(T.boundary, { kg: kgText(S.boundary) })) + '</span></p>' : '') +
        (r.note ? '<p class="td-fd__rec-note">' + icon('info') + '<span>' + esc(r.note) + '</span></p>' : '');
      q('[data-td-fd-closure]').hidden = !r.hasZip;
      S.list = r.items; S.shown = Math.min(r.items.length, S.group === 'k' ? 8 : 6);
      grid.innerHTML = r.items.slice(0, S.shown).map(card).join('');
      more.hidden = S.shown >= r.items.length;
      q('[data-td-fd-empty]').hidden = r.items.length > 0;
    }
    q('[data-td-fd-more]').addEventListener('click', function () {
      var grid = q('[data-td-fd-grid]'), add = S.list.slice(S.shown, S.shown + 6), before = grid.children.length;
      grid.insertAdjacentHTML('beforeend', add.map(card).join(''));
      S.shown += add.length;
      this.hidden = S.shown >= S.list.length;
      var first = grid.children[before] && grid.children[before].querySelector('a');
      if (first) first.focus();
      var st = q('[data-td-fd-status]'); if (st) st.textContent = fill(T.moreAdded, { n: add.length });
    });
    qa('[data-td-fd-cl]').forEach(function (b) {
      b.addEventListener('click', function () { setClosure(b.getAttribute('data-td-fd-cl')); renderResult(); persist(); });
    });

    // ---------- answers
    qa('[data-td-fd-who]').forEach(function (b) {
      b.addEventListener('click', function () {
        S.who = S.group = b.getAttribute('data-td-fd-who'); S.size = null;
        go(S.group === 'k' ? 'height' : 'size');
      });
    });
    qa('[data-td-fd-size]').forEach(function (b) { b.addEventListener('click', function () { S.size = b.getAttribute('data-td-fd-size'); go('weight'); }); });
    qa('[data-td-fd-warm]').forEach(function (b) { b.addEventListener('click', function () { S.warm = parseInt(b.getAttribute('data-td-fd-warm'), 10); go('closure'); }); });
    qa('[data-td-fd-closure-q]').forEach(function (b) {
      b.addEventListener('click', function () { setClosure(b.getAttribute('data-td-fd-closure-q')); go(S.group === 'k' ? 'result' : 'colour'); });
    });
    q('[data-td-fd-next="weight"]').addEventListener('click', function () { go(S.group === 'k' ? 'closure' : 'warm'); });
    q('[data-td-fd-next="colour"]').addEventListener('click', function () { go('result'); });
    qa('[data-td-fd-back]').forEach(function (b) { b.addEventListener('click', back); });
    q('[data-td-fd-restart]').addEventListener('click', function () {
      reset();
      qa('.td-fd__chip').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      setClosure('loop');
      show('who', false);
      forget();
    });

    reset();
    root.classList.add('td-js');
    var who = /[?&]fuer=([^&#]+)/.exec(location.search);
    if (who && /kind/i.test(decodeURIComponent(who[1]))) { S.who = S.group = 'k'; initStep = 'height'; initHist = [{ step: 'who', who: null, group: null, size: null }]; }
    else if (who && /erwachsen/i.test(decodeURIComponent(who[1]))) { S.who = S.group = 'a'; initStep = 'size'; initHist = [{ step: 'who', who: null, group: null, size: null }]; }
    // A saved record holds the answers and the current step, not the path: the path is rebuilt from the four possible
    // routes (Codex r10–r12). Anything that does not fit a route, or lacks an answer the step needs, is dropped.
    var KID_SIZES = ['90x120', '100x150', '110x170'];
    function routeFor(d) {
      // [step, who, group, size, needs] — who/group/size = state when leaving that step (as hist entries record it)
      var a = d.size, k = d.kidSize;
      if (d.sw) return [['who', 'k', 'k', null], ['height', 'k', 'k', k], ['weight', 'k', 'k', k], ['size', 'a', 'a', a], ['weight', 'a', 'a', a], ['warm', 'a', 'a', a], ['closure', 'a', 'a', a], ['colour', 'a', 'a', a], ['result', 'a', 'a', a]];
      if (d.who === 'a') return [['who', 'a', 'a', null], ['size', 'a', 'a', a], ['weight', 'a', 'a', a], ['warm', 'a', 'a', a], ['closure', 'a', 'a', a], ['colour', 'a', 'a', a], ['result', 'a', 'a', a]];
      if (d.who === 'k' && d.group === 'a') return [['who', 'k', 'k', null], ['height', 'k', 'a', a], ['weight', 'k', 'a', a], ['warm', 'k', 'a', a], ['closure', 'k', 'a', a], ['colour', 'k', 'a', a], ['result', 'k', 'a', a]];
      if (d.who === 'k' && d.group === 'k') return [['who', 'k', 'k', null], ['height', 'k', 'k', a], ['weight', 'k', 'k', a], ['closure', 'k', 'k', a], ['result', 'k', 'k', a]];
      return null;
    }
    function rebuild(d) {
      // returns the path (hist) to d.step or null
      if (!d || d.v !== 2 || typeof d.step !== 'string' || !Object.prototype.hasOwnProperty.call(steps, d.step)) return null;
      if (d.step === 'who') return [];
      if (!(d.closure === 'loop' || d.closure === 'zip')) return null;
      if (!Array.isArray(d.colours) || d.colours.some(function (c) { return typeof c !== 'string'; })) return null;
      if (!(d.bw === null || (typeof d.bw === 'number' && isFinite(d.bw) && d.bw >= 1 && d.bw <= 250))) return null;
      if (!(d.warm === null || d.warm === 2 || d.warm === 3 || d.warm === 4)) return null;
      if (d.sw && (d.who !== 'a' || d.group !== 'a' || KID_SIZES.indexOf(d.kidSize) < 0)) return null;
      var r = routeFor(d);
      if (!r) return null;
      var idx = -1;
      for (var i = r.length - 1; i >= 0; i--) if (r[i][0] === d.step) { idx = i; break; }   // with the switch: the adult weight step
      if (idx < 0) return null;
      // answers every step after the respective question needs
      var passed = r.slice(0, idx).map(function (e) { return e[0]; });
      var adultSizes = ['135x200', '150x220'];
      if (passed.indexOf('size') >= 0 && adultSizes.indexOf(d.size) < 0) return null;
      if (passed.indexOf('height') >= 0 && !d.sw && (d.group === 'k' ? KID_SIZES.indexOf(d.size) < 0 : adultSizes.indexOf(d.size) < 0)) return null;
      if (passed.indexOf('weight') >= 0 && d.bw === null) return null;
      if (passed.indexOf('warm') >= 0 && d.warm === null) return null;
      if (d.step === 'size' && !(d.size === null || adultSizes.indexOf(d.size) >= 0)) return null;
      return r.slice(0, idx).map(function (e) { return { step: e[0], who: e[1], group: e[2], size: e[3] }; });
    }
    // back from a product page / reload: answers + step from this tab's sessionStorage (only after the visitor answered)
    var nav = '', saved = null;
    try { var ne = performance.getEntriesByType('navigation')[0]; nav = ne ? ne.type : ''; } catch (e) { nav = ''; }
    if (nav === 'back_forward' || nav === 'reload') { try { saved = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { saved = null; } }
    var savedHist = saved ? rebuild(saved) : null;
    if (!savedHist) saved = null;
    if (saved) {
      S.who = saved.who || null; S.group = saved.group || null; S.size = saved.size || null;
      S.bw = saved.bw == null ? null : saved.bw; S.warm = saved.warm || null;
      setClosure(saved.closure || 'loop');
      setupColours();
      var want = saved.colours || [];
      S.colours = colours.filter(function (c) { return want.indexOf(c.label) >= 0; });
      qa('.td-fd__chip').forEach(function (x, j) { x.setAttribute('aria-pressed', want.indexOf(colours[j].label) >= 0 ? 'true' : 'false'); });
      S.sw = !!saved.sw; S.kidSize = saved.sw ? saved.kidSize : null;
      hist = savedHist;
      show(saved.step, false, false);
    } else {
      forget();
      hist = initHist.slice(); show(initStep, false, false);
    }
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-td-fd]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
